import ControlViewModel from '@/ViewModels/ControlViewModel';
import LinkViewModel from '@/ViewModels/Controls/LinkViewModel';
import MultiSelectAutoComplete from '@/ViewModels/Controls/MultiSelectAutoCompleteViewModel';
import ComponentManager from '@/Management/ComponentManager';

/**
 * Das ViewModel für die AssociationMultiAutocompleteBox
 */
export default class AssociationMultiAutocompleteBoxViewModel extends ControlViewModel {
    
    /**
     * Die wählbaren Optionen
     */
    public multiSelectAutoComplete: MultiSelectAutoComplete;

    /**
     * Das ViewModel für den Link zum Erzeugen eines neuen Objekts
     */
    public linkCreate: LinkViewModel;

    /**
     * Das ViewModel für den Link zum Selektieren eines bestehenden Objekts
     */
    public linkSelect: LinkViewModel;

    /**
     * @param {object} params - Ein Objekt mit Optionen für das Control
     */
    constructor(params: any) {
        super(params);
        this.multiSelectAutoComplete = this.paramOrDefault(params.multiSelectAutoComplete, null);
        this.linkCreate = this.paramOrDefault(params.linkCreate, null);
        this.linkSelect = this.paramOrDefault(params.linkSelect, null);
    }
}

ComponentManager.setViewModel('AssociationMultiAutocompleteBoxViewModel', AssociationMultiAutocompleteBoxViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');